// tokenContractConfig.js

// Import the ABI from a JSON file (assuming the ABI file is located in the 'abis' directory)
import stakingContractABI from '../abi/stakingContractABI.json';

// Define the contract address (replace '0x123...' with your contract's actual address)
export const stakingContractAddress = '0x79E2638160Da8bf09593D31EB2FE27F92d7E413D';

// Export the ABI
export const stakingAbi = stakingContractABI;